module.exports = __webpack_public_path__ + "img/ETLogoBlack.f7b20e18.png";